import { ComponentType, CSSProperties, ReactNode } from 'react';
import { Box, Container, Flex, Text } from '@backstage/ui';
import { LinkButton } from '../LinkButton/LinkButton';

import styles from './CallToActionCard.module.css';

interface CallToActionCardProps {
  title: string;
  subtitle: string | ReactNode;
  ctas: Array<{
    ctaText: string;
    to: string;
    variant: 'primary' | 'secondary';
  }>;
  gradient: boolean;
  cardPadding: string;
  fullWidth?: boolean;
}

type CardContainerProps = {
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

export const CallToActionCard = (props: CallToActionCardProps) => {
  const { title, subtitle, ctas, gradient, cardPadding, fullWidth } = props;
  const CardContainer: ComponentType<CardContainerProps> = fullWidth
    ? Box
    : Container;
  const cardClassName = [
    styles.card,
    !fullWidth && styles.contained,
    gradient && styles.gradient,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <CardContainer className={cardClassName} style={{ padding: cardPadding }}>
      <Text as="h2" className={styles.title}>
        {title}
      </Text>
      <Text as="p" className={styles.subtitle}>
        {subtitle}
      </Text>
      <Flex gap="4">
        {ctas.map(cta => (
          <LinkButton
            key={cta.ctaText}
            to={cta.to}
            label={cta.ctaText}
            solid={cta.variant === 'primary'}
          />
        ))}
      </Flex>
    </CardContainer>
  );
};
